import { Phone, Plus, Minus } from "lucide-react";
import { useState } from "react";
import PrimaryButton from "../../../reusableUi/PrimaryButton";

  const faqs = [
    {
      question: "Which areas do you serve?",
      answer:
        "We provide plumbing services across multiple neighborhoods in Chicago. Each location receives fast, professional, and reliable service from our local team.",
      open: "plus",
      close: "minus",
    },
    {
      question: "Do you offer emergency services in all locations?",
      answer:
        "Yes. Our emergency plumbing team responds quickly to urgent issues in every service area, minimizing damage and restoring plumbing safely and efficiently.",
      open: "plus",
      close: "minus",
    },
    {
      question: "Are your plumbers familiar with local buildings?",
      answer:
        "Absolutely. Our team has extensive experience working in apartments, condos, and older homes in each neighborhood, ensuring safe and effective repairs.",
      open: "plus",
      close: "minus",
    },
    {
      question: "Can I schedule service in my specific neighborhood?",
      answer:
        "Yes. You can book services for your area directly, and our local team will arrive on time with the right tools to handle the job efficiently.",
      open: "plus",
      close: "minus",
    },
    {
      question: "Do you offer transparent pricing for each location?",
      answer:
        "Yes. We provide clear upfront pricing for every service in every neighborhood, so you know exactly what to expect without surprises.",
      open: "plus",
      close: "minus",
    },
    {
      question: "How do you ensure high-quality service locally?",
      answer:
        "Each location is supported by experienced plumbers who follow strict quality protocols. Our focus is on reliable, long-lasting solutions for every client.",
      open: "plus",
      close: "minus",
    },
  ];
export default function FAQs() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (i) => setOpenIndex(openIndex === i ? null : i);

  return (
    <section id="faqs" className="max-w-[90%] xl:max-w-6xl mx-auto space-y-12">

      {/* Header row */}
        <div className="space-y-4">
          <div className="inline-flex items-center gap-2 bg-blue-50 border border-blue-100 text-blue-700 text-xs font-bold tracking-widest uppercase px-4 py-2 rounded-full">
            FAQs
          </div>
          <h2 className="font-black text-gray-900 text-4xl lg:text-5xl tracking-tight leading-tight">
            What People Ask
          </h2>
          <p className="text-gray-500 text-lg leading-relaxed max-w-xl">
            Our services are built on trust, skill, and attention to detail. Honest, direct answers — every time.
          </p>
        </div>

        {/* Desktop CTA */}
          

      {/* Accordion */}
      <div className="space-y-3 w-full">
        {faqs.map((faq, i) => (
          <div
            key={i}
            className="bg-white border border-gray-100 rounded-2xl shadow-sm overflow-hidden"
          >
            <button
              onClick={() => toggle(i)}
              className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left"
            >
              <span className="font-bold text-gray-900 text-[15px] leading-snug">
                {faq.question}
              </span>
              <span className={`flex-shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition-colors duration-200 ${openIndex === i ? "bg-blue-600 text-white" : "bg-gray-100 text-gray-500"}`}>
                {openIndex === i
                  ? <Minus className="w-4 h-4" />
                  : <Plus className="w-4 h-4" />}
              </span>
            </button>

            {openIndex === i && (
              <div className="px-6 pb-5">
                <p className="text-gray-500 text-sm leading-relaxed border-t border-gray-100 pt-4">
                  {faq.answer}
                </p>
              </div>
            )}
          </div>
        ))}
        
      </div>
<div className="mt-6 bg-blue-50 border border-blue-100 rounded-2xl p-6 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
  <div>
    <h3 className="font-black text-gray-900 text-xl leading-tight">Still have questions?</h3>
    <p className="text-gray-500 text-sm mt-1">Our team is happy to help — reach out anytime.</p>
  </div>
  <PrimaryButton />
</div>
    </section>
  );
}
